import { SvgIcon, SvgIconProps } from "@mui/material";

export const HelenaSendIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 18">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.143"
        d="M7.753 10H4.091"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.143"
        d="m3.993 4.418 9.732 4.864a.802.802 0 0 1 0 1.435l-9.732 4.865a.802.802 0 0 1-1.135-.923L4.092 10 2.858 5.34a.802.802 0 0 1 1.135-.922Z"
        clip-rule="evenodd"
      />
      <path
        fill="currentColor"
        d="M11.297.93a.126.126 0 0 1-.015.062.1.1 0 0 1-.052.041l-.505.216-.237.542a.099.099 0 0 1-.041.052.125.125 0 0 1-.063.015.125.125 0 0 1-.064-.015.1.1 0 0 1-.04-.052l-.23-.542-.483-.216a.1.1 0 0 1-.052-.04A.126.126 0 0 1 9.5.928c0-.025.005-.046.015-.063a.1.1 0 0 1 .052-.04l.482-.217.23-.542a.1.1 0 0 1 .041-.052.125.125 0 0 1 .064-.015c.024 0 .045.005.063.015.017.01.03.027.04.052l.238.542.505.216a.1.1 0 0 1 .052.04c.01.018.015.04.015.064Zm4.425 0c0 .019-.005.039-.014.059a.094.094 0 0 1-.052.044l-.483.216-.23.535a.1.1 0 0 1-.041.052.126.126 0 0 1-.063.015.126.126 0 0 1-.063-.015.1.1 0 0 1-.041-.052l-.23-.535-.513-.216a.1.1 0 0 1-.052-.04.126.126 0 0 1-.014-.064c0-.025.005-.046.014-.063a.1.1 0 0 1 .052-.04l.513-.217.23-.535a.1.1 0 0 1 .04-.052.125.125 0 0 1 .064-.015c.025 0 .046.005.063.015a.1.1 0 0 1 .04.052l.231.535.483.216c.024.01.042.025.052.045.01.02.014.04.014.06Zm-1.284 3.262c0 .04-.011.078-.034.115a.222.222 0 0 1-.092.086l-1.032.483-.468 1.04a.22.22 0 0 1-.086.094.22.22 0 0 1-.115.033.22.22 0 0 1-.115-.033.222.222 0 0 1-.085-.093l-.468-1.04-1.025-.484a.221.221 0 0 1-.134-.2c0-.04.012-.079.034-.116a.221.221 0 0 1 .093-.085l1.032-.491.468-1.033a.22.22 0 0 1 .2-.134.22.22 0 0 1 .2.134L13.28 3.5l1.032.49c.044.02.076.049.096.086.02.037.03.076.03.115Z"
      />
    </svg>
  </SvgIcon>
);
